module.exports = __webpack_public_path__ + "static/img/contact_community.1784115679763.png";